var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEditorEraser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5226 10.5045L11.6992 22.3885C11.5988 22.4894 11.4632 22.5452 11.3223 22.5452H6.18129C6.03929 22.5452 5.90371 22.4883 5.80441 22.3885L0.703067 17.2611C-0.234356 16.3188 -0.234356 14.7896 0.703067 13.8473L13.7768 0.706669C14.7142 -0.235556 16.2356 -0.235556 17.1731 0.706669L23.5246 7.09073C24.462 8.03296 24.462 9.56219 23.5246 10.5045H23.5226ZM6.55299 9.48282L1.45684 14.6051C0.935831 15.1288 0.935831 15.9776 1.45684 16.5013L6.40239 21.4722H11.1011L14.791 17.7634L6.55299 9.48282ZM15.5459 17.0045L22.7677 9.74574C23.2887 9.22205 23.2887 8.37318 22.7677 7.8495L16.4162 1.46543C15.8952 0.941751 15.0506 0.941751 14.5296 1.46543L7.30783 8.72423L15.5459 17.0045ZM6.18017 24.5262C5.8855 24.5262 5.64634 24.2858 5.64634 23.9897C5.64634 23.6935 5.8855 23.4531 6.18017 23.4531H24.4662C24.7608 23.4531 25 23.6935 25 23.9897C25 24.2858 24.7608 24.5262 24.4662 24.5262H6.18017Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEditorEraser);
export default __webpack_public_path__ + "static/media/ImageEditorEraser.877159055094fb5446eaf4288a75f943.svg";
export { ForwardRef as ReactComponent };